import React, {useState} from "react";
import "./AchievementCard.scss";

export default function AchievementCard({cardInfo, isDark}) {
  const [isOpen, setIsOpen] = useState(false);
  function openUrlInNewTab(url, name) {
    if (!url) {
      console.log(`URL for ${name} not found`);
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  return (
    <div className={isDark ? "dark-mode certificate-card project-card-relative" : "certificate-card project-card-relative"}>
      <div className="certificate-image-div">
        {cardInfo.image ? (
          <img
            src={cardInfo.image}
            alt={cardInfo.imageAlt || "Card Thumbnail"}
            className="card-image"
          ></img>
        ) : null}
      </div>
      <div className="certificate-detail-div">
        <h5 className={isDark ? "dark-mode card-title" : "card-title"}>
          {cardInfo.title}
        </h5>
        <p className={isDark ? "dark-mode card-subtitle" : "card-subtitle"}>
          {cardInfo.description}
        </p>
      </div>
      <div className="certificate-card-footer">
        {cardInfo.footer && cardInfo.footer.map((v, i) => {
          return (
            <span
              key={i}
              className={
                isDark ? "dark-mode certificate-tag" : "certificate-tag"
              }
              onClick={() => openUrlInNewTab(v.url, v.name)}
            >
              {v.name}
            </span>
          );
        })}
        {cardInfo.projectDetails && (
          <span
            className={
              isDark ? "dark-mode certificate-tag" : "certificate-tag"
            }
            onClick={() => setIsOpen(true)}
          >
            Details
          </span>
        )}
      </div>

      {cardInfo.projectDetails && (
        <div className={`achievement-card-overlay ${isOpen ? 'active' : ''}`}>
          <div className="header">
            <h5 className="card-title" style={{ margin: 0, fontSize: '1.2rem' }}>{cardInfo.title}</h5>
            <button className="close-btn" onClick={() => setIsOpen(false)}>×</button>
          </div>
          <p className="project-detail-text">
            {cardInfo.projectDetails}
          </p>
          <button className="back-btn" onClick={() => setIsOpen(false)}>
            Back
          </button>
        </div>
      )}
    </div>
  );
}
